import { styled, theme } from "../../../../../styles/stitches.config"
import SvgThankYouContract from "../icons/ThankYouContract"

export const SMainContent = styled("div", {
  display: "flex",
  gap: theme.space.s5,
  padding: theme.space.s4,
  scrollBehavior: "smooth",

  flexDirection: "column",
  alignItems: "center",

  "@md": {
    flexDirection: "row",
  },
})

export const STitle = styled("h2", {
  color: theme.colors.primary,
  textTransform: "uppercase",
  margin: 0,

  fontFamily: theme.fonts.default,

  fontSize: theme.sizes.s7,
  fontWeight: theme.fontWeights.bold,

  "@md": {
    fontSize: theme.sizes.s8_5,
  },
})

export const SLargeTitle = styled("h1", {
  color: theme.colors.primary,
  textTransform: "uppercase",
  margin: 0,

  fontFamily: theme.fonts.default,

  fontSize: theme.sizes.s8,
  fontWeight: theme.fontWeights.bold,

  "@md": {
    fontSize: theme.sizes.s10_5,
  },
})

export const SDescription = styled("p", {
  color: theme.colors.texts,
  fontFamily: theme.fonts.default,
  fontSize: theme.sizes.s3_5,
  lineHeight: theme.sizes.s6,

  "@md": {
    fontSize: theme.sizes.s4,
  },

  "@xl": {
    fontSize: theme.sizes.s4_5,
    lineHeight: theme.sizes.s8,
  },
})

export const STextWrapper = styled("div", {
  display: "flex",
  flexDirection: "column",
})

export const SIcon = styled(SvgThankYouContract, {
  height: 300,
  width: 300,

  "@md": {
    height: 400,
    width: 400,
  },
})

export const SManufacturerCard = styled("a", {
  backgroundColor: theme.colors.white,
  borderWidth: theme.sizes.s0_5,
  borderStyle: "solid",
  borderColor: theme.colors.lines,
  borderRadius: theme.radii.default,

  boxShadow: theme.shadows.default,

  maxWidth: 388,

  hover: {
    borderColor: theme.colors.secondary,
  },
})

export const SManufacturerCardHeader = styled("div", {
  padding: theme.space.s4,
  borderBottomStyle: "solid",
  borderBottomWidth: theme.sizes.s0_5,
  borderColor: theme.colors.lines,

  display: "flex",
  alignItems: "center",
  justifyContent: "center",
})

export const SManufacturerCardLogo = styled("span", {
  height: theme.sizes.s14,
  width: theme.sizes.s50,
})

export const SManufacturerCardDescription = styled("div", {
  paddingLeft: theme.space.s4,
  paddingRight: theme.space.s4,
  paddingTop: theme.space.s6,
  paddingBottom: theme.space.s6,

  borderBottomStyle: "solid",
  borderBottomWidth: theme.sizes.s0_5,
  borderColor: theme.colors.lines,
})

export const SManufacturerCardFooter = styled("div", {
  padding: theme.space.s4,
  color: theme.colors.textsAlt,

  fontSize: theme.fontSizes.small,
  fontFamily: theme.fonts.default,
  fontWeight: theme.fontWeights.semiBold,
  lineHeight: theme.sizes.s6,
  textAlign: "center",

  "@lg": {
    lineHeight: theme.sizes.s6_5,
  },

  "@xl": {
    lineHeight: theme.sizes.s7,
  },

  hover: {
    color: theme.colors.secondary,
  },
})

export const SWhatNowGrid = styled("div", {
  display: "grid",
  gap: theme.space.s4,
  gridTemplateColumns: `1fr`,

  "@lg": {
    gridTemplateColumns: `1fr 1fr`,
  },
})

export const SWhatNowItem = styled("div", {
  display: "flex",
  gap: theme.space.s4,
})

export const SWhatNowContent = styled("div", {})

export const SWhatNowTitle = styled("h3", {
  color: theme.colors.primary,
  textTransform: "uppercase",
  margin: theme.space.s0,
  fontFamily: theme.fonts.default,
  fontWeight: theme.fontWeights.bold,

  fontSize: theme.sizes.s6,
  lineHeight: theme.sizes.s8,

  "@xl": {
    fontSize: theme.sizes.s8,
    lineHeight: theme.sizes.s10,
  },
})

export const SWhatNowDescription = styled("p", {
  color: theme.colors.texts,
  fontFamily: theme.fonts.default,
  fontSize: theme.sizes.s3_5,
  lineHeight: theme.sizes.s6,

  "@md": {
    fontSize: theme.sizes.s4,
  },

  "@xl": {
    fontSize: theme.sizes.s4_5,
    lineHeight: theme.sizes.s8,
  },
})

export const SWhatNowIcon = styled("div", {
  flexShrink: 0,
  width: theme.sizes.s36,

  "@xl": {
    width: theme.sizes.s44,
  },
})

export const SWhatNowIndex = styled("p", {
  color: theme.colors.secondary,
  textTransform: "uppercase",
  margin: theme.space.s0,
  fontFamily: theme.fonts.default,
  fontWeight: theme.fontWeights.bold,
  lineHeight: theme.sizes.s6,
  fontSize: theme.sizes.s6,
})
